import { useTendency } from "../utils/tendency";
import type { CartNotificationPoint } from '../../notifications/Notification.types';

export default function PointProbability({ point, isFlash }: { point: CartNotificationPoint, isFlash: boolean }) {
    const showTendency = useTendency();

    return (
        <>
            {!isFlash ?
                <>
                    <div>Total probability to exceed a 5-year return period threshold: {Math.ceil(point.TotalProbH)}%</div>
                    <div>Total probability to exceed a 20-year return period threshold: {Math.ceil(point.TotalProbE)}%</div>
                    <div>Probability tendency: <img title="Reporting point tendency" width="22rem" src={showTendency(point.Tendency)} /></div>
                </>
                :
                <>
                    <div>% COSMO-LEPS above 5-year return period: {Math.ceil(point.ff_t_gt5 * 100)}%</div>
                    {/* <Tooltip title={`+${point.rep_lt} hours from forecast`}>
                        <div>Earliest peak: <strong>{moment.utc(point.Forecast_date, 'YYYYMMDDHH').add(point.rep_lt, 'hours').format("YYYY-MM-DD HH:mm")} UTC</strong></div>
                    </Tooltip> */}
                </>
            }
        </>
    );
}
